/**
 * Uplifted pieces of apps/web `helper/paymenthelper`, seeded with the three the feature gate needs
 * (`helpers/featureRestrictionHelper`: Quick Settle shows only when a quick payment mode is
 * permitted). WEB's bodies.
 *
 * ⚠️ Mobile keeps its own three for its non-adopted screens (checkout's adoption converges them):
 * its `quickPaymentFilter` deep-clones the modes it returns, and its `getPermittedPaymentModes`
 * delegates to rista-pos-common's `getPermittedPaymentModesCommon`.
 */
import store from "../../redux-store";
import { EXTERNAL } from "../../utils/constants";
import { getSelectedChannel } from "../saleHelpers";

export const quickPaymentFilter: any = () => {
  const paymentdefs = store.getState().businessStore?.businessData?.paymentdefs || [];
  const quickPayment = store.getState().businessStore?.businessData?.quickPaymentModes || [];
  if (!quickPayment?.length || !paymentdefs?.length) return [];
  let filterData = [];
  filterData = paymentdefs.filter((listItem: any) => quickPayment.includes(listItem.mode));
  return filterData;
}

// Return payment modes that are enabled for the selected channel
// and permitted for the current user
export const getPermittedPaymentModes: any = (payment: any) => {
  if (!payment?.length) return [];
  const userData = store.getState().businessStore.userData,
    isOffline = store.getState().businessStore?.isOffline;
  const selectedChannel = getSelectedChannel();
  const saleData = store.getState().saleDataStore?.saleData;
  const permittedPaymentModes = userData?.permittedPaymentModes;

  // If explicitly empty array → return empty list ,i.e. no payment modes are permitted.
  if (Array.isArray(permittedPaymentModes) && permittedPaymentModes.length === 0) {
    return [];
  }

  const paymentList: any = [];

  payment.forEach((listItem: any) => {

    if (listItem.type === EXTERNAL && isOffline) return;

    
    const selectedChannelDef = saleData?.channelDefId || selectedChannel?.channelDefId || '';
    // restrict payment modes based on user permissions, if any, otherwise permit all the modes
    const isPermittedPaymentMode = permittedPaymentModes?.length ?
      permittedPaymentModes.includes(listItem.mode) : true,

      // checks whether the payment mode is enabled
      isEnabled = listItem.enable,

      // match the channelDefId, if present in the payment mode definition, otherwise consider it as valid for the channel
      isChannelIdMatched = listItem.channelDefIds?.length ?
        listItem.channelDefIds.includes(selectedChannelDef) : true;
    if (isChannelIdMatched && isEnabled && isPermittedPaymentMode)
      paymentList.push(listItem);

  })
  return paymentList;
}

export const getQuickPaymentMethods: any = () => {
  const filterPayment = quickPaymentFilter();
  return getPermittedPaymentModes(filterPayment);
}
